
import axios from 'axios'

function findPoints(points)
{
    let query =""
    for (var i=0;i< points.length;i++)
    {
        query=`${query}&points=${points[i]}`;
    }
    return axios.get(`${process.env.VUE_APP_APIURL}/point?${query}`)
    .then(resp => {
        return resp.data
    })
}
function getPoint(id){
    return axios.get(`${process.env.VUE_APP_APIURL}/point/${id}`)
    .then(resp => {
        return resp.data
    })
}
function deleteDevice(pointId){
    return axios.delete(`${process.env.VUE_APP_APIURL}/point/${pointId}/device`).then(res=>{
        return res.data
    })
}

function updateDevice(pointId,macAddress,gateway){
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/device`,{
        macAddress,
        gateway
    })
}
function deleteProfile(pointId){
    return axios.delete(`${process.env.VUE_APP_APIURL}/point/${pointId}/profile`).then(res=>{
        return res.data
    })
}

function updateProfile(pointId,profile){
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/profile`,{
        sampleSize:profile.sampleSize,
        samplingRateIndex: profile.samplingRate.index,
        accelerometerRangeIndex : profile.accelerometerRange.index,
        sensorSelectionIndex: profile.sensorSelection.index,
        window:'rectangular'
    })
}
function deleteTrigger(pointId){
    return axios.delete(`${process.env.VUE_APP_APIURL}/point/${pointId}/trigger`).then(res=>{
        return res.data
    })
}
function deletePeriodic(pointId){
    return axios.delete(`${process.env.VUE_APP_APIURL}/point/${pointId}/periodic`).then(res=>{
        return res.data
    })
}
function updatePeriodic(pointId,periodic){
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/periodic`,{
        sleepAmountIndex:periodic.sleepAmount.index,
    })
}

function updateTrigger(pointId,trigger){
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/trigger`,{
        trigger:trigger,
    })
}

function updateChannelGroups(pointId,channelGroups){
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/channelGroup`,{
        channelGroups:channelGroups,
    })
}

export default  {
    findPoints,
    getPoint,
    updateDevice,
    deleteDevice,
    updateProfile,
    deleteProfile,
    updatePeriodic,
    deletePeriodic,
    deleteTrigger,
    updateTrigger,
    updateChannelGroups
};